import randomString from '@/utils/random-string';

interface IconFilterAltGradientProps {
  /** id must be unique for each instance */
  id?: string;
  size?: number;
  from?: string;
  to?: string;
}

const IconFilterAltGradient = ({
  id: _id,
  size = 16,
  from = '#5AE4FF',
  to = '#A7FF7B',
}: IconFilterAltGradientProps) => {
  const id = _id || `icon-add-gradient-${randomString(6)}`;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
      <path
        d="M7.33274 13.3327C7.14385 13.3327 6.98551 13.2688 6.85774 13.141C6.72996 13.0132 6.66607 12.8549 6.66607 12.666V8.66602L2.7994 3.73268C2.63274 3.51046 2.60774 3.27713 2.7244 3.03268C2.84107 2.78824 3.04385 2.66602 3.33274 2.66602H12.6661C12.955 2.66602 13.1577 2.78824 13.2744 3.03268C13.3911 3.27713 13.3661 3.51046 13.1994 3.73268L9.33274 8.66602V12.666C9.33274 12.8549 9.26885 13.0132 9.14107 13.141C9.01329 13.2688 8.85496 13.3327 8.66607 13.3327H7.33274Z"
        fill={`url(#${id})`}
      />
      <defs>
        <linearGradient id={id} x1="2.65234" y1="7.99935" x2="13.3465" y2="7.99935" gradientUnits="userSpaceOnUse">
          <stop stopColor={from} />
          <stop offset="1" stopColor={to} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default IconFilterAltGradient;
